// extracted by mini-css-extract-plugin
export default {"whatsapp":"styles_whatsapp__YKk3k","wrapper":"styles_wrapper__U2lMb"};